import axios from "axios";
import { formatStreamChatErrorMessage } from "../utils/format";

export const fetchConfig = (slug) => axios.get(`/api/c/${slug}/config`);

export const chatbotLogin = (slug, username, password) =>
  // withCredentials requis pour que le navigateur accepte et stocke le cookie HttpOnly de la réponse
  axios.post(`/api/c/${slug}/login`, { username, password }, { withCredentials: true });

export const chatbotLogout = (api, slug) => api.post(`/api/c/${slug}/logout`);

export const fetchMe = (api, slug) => api.get(`/api/c/${slug}/me`);

export const sendMessage = (api, slug, question, conversationId) => {
  const payload = { question };
  if (conversationId) payload.conversation_id = conversationId;
  return api.post(`/api/c/${slug}/chat`, payload);
};

export const streamMessage = async (slug, question, conversationId) => {
  const payload = { question };
  if (conversationId) payload.conversation_id = conversationId;

  const resp = await fetch(`/api/c/${slug}/chat/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    // Indispensable pour envoyer le cookie HttpOnly de session du chatbot
    credentials: "same-origin",
  });
  if (!resp.ok) {
    let bodyJson = null;
    try {
      bodyJson = await resp.json();
    } catch {
      /* ignore */
    }
    const err = new Error(formatStreamChatErrorMessage(resp.status, bodyJson));
    err.status = resp.status;
    err.detail = bodyJson?.detail;
    throw err;
  }
  return resp;
};

export const fetchConversations = (api, slug) =>
  api.get(`/api/c/${slug}/conversations`);
export const fetchConversation = (api, slug, convId) =>
  api.get(`/api/c/${slug}/conversations/${convId}`);
export const deleteConversation = (api, slug, convId) =>
  api.delete(`/api/c/${slug}/conversations/${convId}`);
